'use server';
import { actionErrorLog } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';

export async function toggleFavoriteAudioStory(
  audioStoryId: string,
): Promise<ActionResult<{ isFavorite: boolean; favoritedAt: string | null }>> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return { success: false, error: 'Not authenticated' };

  try {
    const { getAudioStoryRepository } = await import(
      '@/contexts/audio-stories/repositories'
    );
    const result = await getAudioStoryRepository().toggleFavorite(audioStoryId, familyId);
    return { success: true, data: result };
  } catch (e: unknown) {
    actionErrorLog('toggleFavorite', e);
    return { success: false, error: e instanceof Error ? e.message : 'Unknown error' };
  }
}
